/**
 * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
 *
 * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
 */
export function getTextWidth(text: string, elem: any) {
  const canvas = document.getElementById('canvas-textwidth') || document.createElement('canvas');
  canvas.id = 'canvas-textwidth';
  const context = (canvas as any).getContext('2d');
  context.font = elem.style.font;
  const metrics = context.measureText(text);

  return metrics.width;
}
